import { VerticalTimelineElement } from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { AboutIntro, AboutIntroKicker, AboutIntroTitle, CustomVerticalTimeline, TeamImage, TeamImageCaption, TeamImageWrapper, TimelinePageWrapper } from "./timeLine.styles";
import teamPhoto from "../../Assets/Images/optimized/aboutUs-opt.webp";

const TimeLine = () => {
  const milestones = [
    {
      date: "1993",
      title: "Trucks Limited Founded",
      subtitle: "Southampton",
      summary: "Established as a focused haulage business supporting local construction and groundworks activity.",
    },
    {
      date: "2013",
      title: "Inert Recycling (UK) Limited Formed",
      subtitle: "Hampshire",
      summary: "Expanded service capability beyond haulage, including tipper hire, plant hire, and specialist site support.",
    },
    {
      date: "2013 - 2020",
      title: "Operational Growth",
      subtitle: "South Coast Coverage",
      summary: "Strengthened restoration and disposal network while scaling the fleet to support larger and more complex contracts.",
    },
    {
      date: "Today",
      title: "Highbridge Estates Base",
      subtitle: "Eastleigh",
      summary: "Operating from Eastleigh with a 30+ vehicle fleet, delivering dependable solutions across haulage, plant, and restoration.",
    },
  ];

  return (
    <TimelinePageWrapper>
      <AboutIntro>
        <AboutIntroKicker>Company timeline</AboutIntroKicker>
        <AboutIntroTitle>A practical business built for long-term performance</AboutIntroTitle>
        <p>From our early haulage roots to a multi-service operation, our growth has always been shaped by reliability, safety, and a straightforward commitment to getting the job done properly.</p>
      </AboutIntro>

      <CustomVerticalTimeline>
        {milestones.map((milestone) => (
          <VerticalTimelineElement key={milestone.date + milestone.title} className="vertical-timeline-element--work" date={milestone.date} iconStyle={{ background: "rgb(171, 198, 41)", color: "#fff" }}>
            <h3 className="vertical-timeline-element-title">{milestone.title}</h3>
            <h5 className="vertical-timeline-element-subtitle">{milestone.subtitle}</h5>
            <p>{milestone.summary}</p>
          </VerticalTimelineElement>
        ))}
      </CustomVerticalTimeline>
      <TeamImageWrapper>
        <TeamImage src={teamPhoto} alt="Inert Recycling team" />
        <TeamImageCaption>Our team delivering dependable service across the South Coast.</TeamImageCaption>
      </TeamImageWrapper>
    </TimelinePageWrapper>
  );
};

export default TimeLine;
